const POST_LOAD_WINDOW_MS = 10_000;
const LONG_TASK_THRESHOLD_MS = 50;
export function observePostLoadBlocking(startedAt, onResult) {
    const endsAt = startedAt + POST_LOAD_WINDOW_MS;
    let blockingTimeMs = 0;
    let longTaskCount = 0;
    let finished = false;
    let observer;
    let timer;
    const collect = (entries) => {
        entries.forEach(({ startTime, duration }) => {
            // Clip the blocking portion of the task, including tasks crossing either window edge.
            const blocking = Math.max(0, Math.min(startTime + duration, endsAt) -
                Math.max(startTime + LONG_TASK_THRESHOLD_MS, startedAt));
            if (blocking === 0)
                return;
            blockingTimeMs += blocking;
            longTaskCount += 1;
        });
    };
    const finish = (reason) => {
        if (finished)
            return;
        const observedMs = Math.min(POST_LOAD_WINDOW_MS, Math.max(0, performance.now() - startedAt));
        if (reason === 'complete' && observedMs < POST_LOAD_WINDOW_MS) {
            timer = window.setTimeout(onWindowEnd, Math.max(1, POST_LOAD_WINDOW_MS - observedMs));
            return;
        }
        finished = true;
        const status = reason === 'navigation' && observedMs === POST_LOAD_WINDOW_MS ? 'complete' : reason;
        collect(observer?.takeRecords() ?? []);
        observer?.disconnect();
        window.clearTimeout(timer);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', onPageHide);
        onResult({
            status,
            windowMs: POST_LOAD_WINDOW_MS,
            observedMs,
            blockingTimeMs: status === 'complete' ? blockingTimeMs : null,
            longTaskCount: status === 'complete' ? longTaskCount : null,
        });
    };
    const onVisibilityChange = () => {
        if (document.visibilityState !== 'visible')
            finish('hidden');
    };
    const onPageHide = () => finish('navigation');
    const onWindowEnd = () => finish(document.visibilityState === 'visible' ? 'complete' : 'hidden');
    if (document.visibilityState !== 'visible') {
        finish('hidden');
        return () => { };
    }
    if (typeof PerformanceObserver === 'undefined' ||
        !PerformanceObserver.supportedEntryTypes?.includes('longtask')) {
        finish('unsupported');
        return () => { };
    }
    try {
        observer = new PerformanceObserver((list) => collect(list.getEntries()));
        observer.observe({ type: 'longtask', buffered: true });
    }
    catch {
        finish('unsupported');
        return () => { };
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', onPageHide);
    timer = window.setTimeout(onWindowEnd, Math.max(0, endsAt - performance.now()));
    return () => finish('navigation');
}
//# sourceMappingURL=observePostLoadBlocking.js.map